import React from 'react';
import './PNRListNoResultContainer.css';

import I18n from 'i18n-react';

class PNRListNoResultContainer extends React.Component {
  render() {
    return (
      <div>
        <span>
          <h1 className="PNRListNoResultContainer searchNoResulTitle">
            {I18n.translate('searchResult.msg.exploreAzulAroundTheWorldTitle')}
          </h1>
        </span>
        <span>
          <h1 className="PNRListNoResultContainer searchNoResulText">
            {I18n.translate('searchResult.msg.exploreAzulAroundTheWorldText')}
          </h1>
        </span>
      </div>
    );
  }
}

export default PNRListNoResultContainer;



// WEBPACK FOOTER //
// ./src/page/searchResultPage/components/PNRList/PNRListNoResultContainer.jsx